var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoadingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 58"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_512_13513",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 10C20 12.2013 19.2736 14.3412 17.9335 16.0876C16.5934 17.8341 14.7145 19.0895 12.5882 19.6593C10.4619 20.229 8.20694 20.0812 6.17317 19.2388C4.13939 18.3964 2.44042 16.9064 1.33975 15C0.239075 13.0936 -0.201781 10.8772 0.0855513 8.69474C0.372884 6.51223 1.37235 4.48552 2.92893 2.92893C4.48552 1.37235 6.51223 0.372884 8.69474 0.0855515C10.8772 -0.201781 13.0936 0.239075 15 1.33975L13.8242 3.37626C12.3661 2.53442 10.671 2.19724 9.00168 2.417C7.3324 2.63677 5.78228 3.4012 4.59174 4.59174C3.4012 5.78229 2.63677 7.3324 2.417 9.00168C2.19724 10.671 2.53442 12.3661 3.37626 13.8242C4.2181 15.2823 5.51755 16.4219 7.07307 17.0662C8.62859 17.7105 10.3532 17.8236 11.9796 17.3878C13.6059 16.952 15.0429 15.9918 16.0679 14.6561C17.0929 13.3203 17.6484 11.6837 17.6484 10H20Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20 10C20 12.2013 19.2736 14.3412 17.9335 16.0876C16.5934 17.8341 14.7145 19.0895 12.5882 19.6593C10.4619 20.229 8.20694 20.0812 6.17317 19.2388C4.13939 18.3964 2.44042 16.9064 1.33975 15C0.239075 13.0936 -0.201781 10.8772 0.0855513 8.69474C0.372884 6.51223 1.37235 4.48552 2.92893 2.92893C4.48552 1.37235 6.51223 0.372884 8.69474 0.0855515C10.8772 -0.201781 13.0936 0.239075 15 1.33975L13.8242 3.37626C12.3661 2.53442 10.671 2.19724 9.00168 2.417C7.3324 2.63677 5.78228 3.4012 4.59174 4.59174C3.4012 5.78229 2.63677 7.3324 2.417 9.00168C2.19724 10.671 2.53442 12.3661 3.37626 13.8242C4.2181 15.2823 5.51755 16.4219 7.07307 17.0662C8.62859 17.7105 10.3532 17.8236 11.9796 17.3878C13.6059 16.952 15.0429 15.9918 16.0679 14.6561C17.0929 13.3203 17.6484 11.6837 17.6484 10H20Z",
    stroke: "url(#paint0_linear_512_13513)",
    strokeWidth: 6,
    mask: "url(#path-1-inside-1_512_13513)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_512_13513",
    x1: 10.6745,
    y1: 6.45833,
    x2: 21.3764,
    y2: 10.8879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE2357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE2357",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingIcon);
export default __webpack_public_path__ + "static/media/loading-icon.f7ee8e557aef5f485acc68f0a45495ae.svg";
export { ForwardRef as ReactComponent };